var GoogleMap = function () {
    var map = undefined;
    var loaded = false; // 是否已经加载
    var circleArray = [];
    var polygonArray = [];
    var polyLineArray = [];
    var markerArray = [];
    var labelArray = [];
    var clustererArray = [];
    var drawingManager = undefined;

    var clusterInstance = undefined;

    var markerList = [];

    var EarthRadiusKm = 6378.137; // WGS-84

    this.refreshCluster = function () {
        if (clusterInstance) {
            clusterInstance.clearMarkers();
            clusterInstance = null;
        }

        const customRenderer = {
            render: function (clusterItem) {
                const count = clusterItem.markers.length;
                const div = document.createElement('div');
                div.style.width = '36px';
                div.style.height = '36px';
                div.style.borderRadius = '50%';
                div.style.background = '#1677ff';
                div.style.color = '#fff';
                div.style.display = 'flex';
                div.style.alignItems = 'center';
                div.style.justifyContent = 'center';
                div.style.fontSize = '14px';
                div.style.fontWeight = 'bold';
                div.style.boxShadow = '0 2px 6px #0003';
                div.textContent = count; // 显示聚合数量

                return new google.maps.marker.AdvancedMarkerElement({
                    position: clusterItem.position,
                    content: div
                })
            }
        }

        // 2. 新建聚合
        console.log("2. 新建聚合");
        clusterInstance = new markerClusterer.MarkerClusterer({
            map: map,
            markers: markerList,
            renderer: customRenderer
        });
    }

    function removeElementFromArr(arr, id) {
        if (arr) {
            if (id) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].id == id) {
                        arr[i].overlay.map = null;//.setMap(null);
                        arr.splice(i, 1);
                        break;
                    }
                }
            } else {
                for (i in arr) {
                    arr[i].overlay.map = null;//.setMap(null);
                }
                arr.splice(0, arr.length);
                arr.length = 0;
            }
        }
    }

    /*
      opts = {
        center: [116.404, 39.915], 中心点经纬度
        zoom: 12, 缩放级别
      }
    */
    this.initMap = function (mapId, opts) {
        if (loaded) return;
        if (map != undefined) {
            return;
        }



        if (opts == undefined) {
            opts = {};
        }
        if (opts.center == undefined) {
            opts.center = [116.404, 39.915];// { lat: 39.915, lng: 116.404 };
        }
        if (opts.zoom == undefined) {
            opts.zoom = 14;
        }
        map = new google.maps.Map(document.getElementById(mapId), {
            mapId: mapId,
            center: { lat: parseFloat(opts.center[1]), lng: parseFloat(opts.center[0]) },
            zoom: parseInt(opts.zoom),

            disableDefaultUI: false,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_RIGHT,
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
            },
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
            scrollwheel: true
        });

        // 初始化空聚合
        this.refreshCluster();

        if (opts.completed) {
            // google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
            opts.completed();
            loaded = true;
            // });
        }




    };
    //绘制多边形
    this.drawPolygon = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        // map.clearOverlays();

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            polygonOptions: {
                strokeColor: color,
                strokeWeight: width,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {

                var paths = event.overlay.getPaths();

                var lonlats = "";
                if (paths.length >= 3) {

                    paths.forEach(path => {
                        path.getArray().forEach(point => {
                            if (lonlats != "") lonlats += ";";
                            lonlats += point.lng() + "," + point.lat();
                        })
                    });
                }
            }
        }); // 监听绘图完成事件


    };
    //绘制矩形
    this.drawRectangle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        // map.clearOverlays();

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            rectangleOptions: {
                strokeColor: color,
                strokeWeight: color,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                const bounds = event.overlay.getBounds();
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();

                if (callback) callback(sw.lng(), sw.lat(), ne.lng(), ne.lat());
            }
        });

    };

    //绘制圆
    this.drawCircle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            circleOptions: {
                strokeColor: color,
                strokeWeight: width,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            }
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                var center = event.overlay.getCenter();
                var radius = event.overlay.getRadius();
                callback(center.lng(), center.lat(), radius);
            }
        });
    };

    //绘制线
    this.drawLine = function (width, color, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#0609D8";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#0609D8";

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            polylineOptions: {
                strokeColor: color,
                strokeWeight: width,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                var path = event.overlay.getPath();
                var lonlats = "";
                path.getArray().forEach(point => {
                    if (lonlats != "") lonlats += ";";

                    lonlats += point.lng() + "," + point.lat();
                })
                if (callback) callback(lonlats);
            }
        });

    };
    //绘制点
    this.drawPoint = function (callback) {
        if (!loaded) return;
        // 初始化绘图管理器
        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            markerOptions: {
                draggable: false,
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            drawingManager.setDrawingMode(null);
            var marker = event.overlay;
            if (callback) {
                var p = marker.getPosition();
                callback(p.lng(), p.lat());
            }
            // 启用拖拽功能，允许用户微调标记位置
            marker.setDraggable(true);
            marker.setClickable(false); // 避免拖拽时触发点击
            google.maps.event.addListener(marker, 'dragend', function () {
                var newP = marker.getPosition();
                if (callback) callback(newP.lng(), newP.lat());
            });
        });

    };

    this.setDrawingMode = function (mode) {
        drawingManager.setDrawingMode(mode);

    };

    this.clearAll = function () {
        // 清除所有覆盖物
        circleArray.forEach(item => item.overlay.setMap(null));
        polygonArray.forEach(item => item.overlay.setMap(null));
        polyLineArray.forEach(item => item.overlay.setMap(null));
        markerArray.forEach(item => item.overlay.setMap(null));
        labelArray.forEach(item => item.overlay.setMap(null));

        circleArray = [];
        polygonArray = [];
        polyLineArray = [];
        markerArray = [];
        labelArray = [];
    };

    this.setCenter = function (lng, lat) {
        map.setCenter({ lat: lat, lng: lng });
    };

    // 添加点
    this.addMarker = function (id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight, options) {
        if (!loaded) return;
        if (lng == undefined || lat == undefined) return false;
        if (id == undefined || id == "") id = "marker0";
        if (name == undefined) name = "marker";
        options = options || {};

        var icon = undefined;
        var markerTag = document.createElement('div');
        var markerContent = "";
        markerTag.className = 'marker-tag';
        if (iconUrl) {

            markerContent += "<div class='marker-icon'><img src='" + require("@/" + iconUrl) + "' alt='' /></div>"
            icon = {
                url: require("@/" + iconUrl),
                scaledSize: new google.maps.Size(22, 32),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 25)
            };
        }
        if (name != "") {
            markerContent += ("<div class='marker-name'>" + name + "</div>")
        }
        markerTag.innerHTML = markerContent;
        var position = { lat: lat, lng: lng };
        // map.setCenter(position); 

        //     var myPin = new google.maps.PinElement({
        //     scale: 1.5,
        // });
        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: position,
            content: markerTag,
            gmpDraggable: options.draggable ? true : undefined
        });

        if (callback) {
            marker.addListener('click', callback);
        }

        // 拖拽结束后触发回调
        if (options.draggable && options.onDragEnd) {
            marker.addListener('dragend', function () {
                var pos = marker.position;
                options.onDragEnd(pos.lng, pos.lat);
            });
        }

        markerArray.push({ id: id, overlay: marker });
    };

    // 添加线
    this.addPolyline = function (id, name, coordinators, width, color) {
        if (!loaded) return;
        if (coordinators == undefined || coordinators == "") return false;
        if (id == undefined || id == "") id = "line0";
        if (name == undefined) name = "";
        if (width == undefined || width == "") width = 1;
        if (color == undefined || color == "") color = "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";

        var path = coordinators.map(coor => ({
            lat: coor.lat,
            lng: coor.lng
        }));

        var polyline = new google.maps.Polyline({
            path: path,
            geodesic: true,
            strokeColor: color,
            strokeOpacity: 1.0,
            strokeWeight: width,
            map: map
        });

        // 计算适合所有点的视图
        var bounds = new google.maps.LatLngBounds();
        path.forEach(point => bounds.extend(point));
        map.fitBounds(bounds);

        polyLineArray.push({ id: id, overlay: polyline });
    };

    this.removeMarkerById = function (id) {
        console.log("removeMarkerById id", id);
        if (!loaded) return;
        removeElementFromArr(markerArray, id);
        removeElementFromArr(labelArray, id);
    };

    this.clearMarkers = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray);
        removeElementFromArr(labelArray);
    };

    this.removePolylineById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polyLineArray, id);
    };
    // 批量添加标记到聚合
    this.addMarkersToCluster = function (markersData) {
        if (!markersData || !Array.isArray(markersData) || markersData.length === 0) {
            return;
        }

        const newMarkers = [];

        for (let data of markersData) {
            const { id, name, lng, lat, iconUrl, callback } = data;

            // 检查是否已存在相同id的marker，避免重复添加
            const existingIndex = markerList.findIndex(m => m.markerId === id);
            if (existingIndex !== -1) {
                // 如果已存在，先移除旧的marker
                const oldMarker = markerList[existingIndex];
                if (clusterInstance) {
                    try {
                        if (typeof clusterInstance.removeMarker === 'function') {
                            clusterInstance.removeMarker(oldMarker);
                        } else if (typeof clusterInstance.removeMarkers === 'function') {
                            clusterInstance.removeMarkers([oldMarker]);
                        }
                    } catch (e) {
                        console.warn('Failed to remove marker:', e);
                    }
                }
                markerList.splice(existingIndex, 1);
            }

            var icon = undefined;
            var markerTag = document.createElement('div');
            var markerContent = "";
            markerTag.className = 'marker-tag';
            if (iconUrl) {
                markerContent += "<div class='marker-icon'><img src='" + require("@/" + iconUrl) + "' alt='' /></div>"
                icon = {
                    url: require("@/" + iconUrl),
                    scaledSize: new google.maps.Size(22, 32),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(10, 25)
                };
            }
            if (name != "") {
                markerContent += ("<div class='marker-name'>" + name + "</div>")
            }
            markerTag.innerHTML = markerContent;

            const pos = { lat: lat, lng: lng };

            // 创建标记
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: pos,
                content: markerTag,
            });

            if (callback) marker.addEventListener("click", callback);
            marker.markerId = id;
            markerList.push(marker);
            newMarkers.push(marker);
        }

        // 批量增量添加到聚合，避免重建整个聚合器
        if (clusterInstance && newMarkers.length > 0) {
            try {
                // 尝试使用批量添加方法
                if (typeof clusterInstance.addMarkers === 'function') {
                    clusterInstance.addMarkers(newMarkers);
                } else if (typeof clusterInstance.addMarker === 'function') {
                    // 如果只支持单个添加，则逐个添加
                    newMarkers.forEach(marker => {
                        clusterInstance.addMarker(marker);
                    });
                } else {
                    // 如果不支持增量添加，则刷新整个聚合
                    this.refreshCluster();
                }
            } catch (e) {
                console.warn('Failed to add markers incrementally, refreshing cluster:', e);
                this.refreshCluster();
            }
        }
    };

    // 清除所有聚合标记
    this.clearMarkerCluster = function () {
        if (clusterInstance) {
            try {
                clusterInstance.clearMarkers();
            } catch (e) {
                console.warn('Failed to clear markers:', e);
            }
            // clusterInstance = null;
        }
        // 清除 markerList
        markerList.forEach(marker => {
            try {
                marker.setMap(null);
            } catch (e) {
                console.warn('Failed to remove marker from map:', e);
            }
        });
        markerList = [];
    };

    this.addMarkerToCluster = function (id, name, lng, lat, iconUrl, callback) {
        // 检查是否已存在相同id的marker，避免重复添加
        const existingIndex = markerList.findIndex(m => m.markerId === id);
        if (existingIndex !== -1) {
            // 如果已存在，先移除旧的marker
            const oldMarker = markerList[existingIndex];
            if (clusterInstance) {
                try {
                    if (typeof clusterInstance.removeMarker === 'function') {
                        clusterInstance.removeMarker(oldMarker);
                    } else if (typeof clusterInstance.removeMarkers === 'function') {
                        clusterInstance.removeMarkers([oldMarker]);
                    }
                } catch (e) {
                    console.warn('Failed to remove marker:', e);
                }
            }
            markerList.splice(existingIndex, 1);
        }

        var icon = undefined;
        var markerTag = document.createElement('div');
        var markerContent = "";
        markerTag.className = 'marker-tag';
        if (iconUrl) {
            markerContent += "<div class='marker-icon'><img src='" + require("@/" + iconUrl) + "' alt='' /></div>"
            icon = {
                url: require("@/" + iconUrl),
                scaledSize: new google.maps.Size(22, 32),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 25)
            };
        }
        if (name != "") {
            markerContent += ("<div class='marker-name'>" + name + "</div>")
        }
        markerTag.innerHTML = markerContent;

        const pos = { lat: lat, lng: lng };

        // 创建标记
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: pos,
            content: markerTag,
            // icon: icon
        });

        if (callback) marker.addEventListener("click", callback);
        marker.markerId = id;
        markerList.push(marker);

        // 增量添加到聚合，避免重建整个聚合器
        if (clusterInstance) {
            try {
                // 尝试使用增量添加方法
                if (typeof clusterInstance.addMarker === 'function') {
                    clusterInstance.addMarker(marker);
                } else if (typeof clusterInstance.addMarkers === 'function') {
                    clusterInstance.addMarkers([marker]);
                } else {
                    // 如果不支持增量添加，则刷新整个聚合
                    // this.refreshCluster();
                }
            } catch (e) {
                console.warn('Failed to add marker incrementally, refreshing cluster:', e);
                // this.refreshCluster();
            }
        }
    }


    // 添加多边形
    this.addPolygon = function (
        id,
        name,
        coordanites,
        strokeWidth,
        strokeColor,
        fillColor
    ) {
        if (!loaded) return;
        if (coordanites == undefined || coordanites == "") return false;
        if (id == undefined || id == "") id = "region0";
        if (name == undefined) name = "";
        if (strokeWidth == undefined) strokeWidth = 2;
        if (strokeColor == undefined) strokeColor = "#FF0000";
        if (fillColor == undefined) fillColor = "#FF0000";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#FF0000";
        if (fillColor.length != 7) fillColor = "#FF0000";

        var path = coordanites.map(coor => ({
            lat: coor.lat,
            lng: coor.lng
        }));

        var polygon = new google.maps.Polygon({
            paths: path,
            strokeColor: strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: strokeWidth,
            fillColor: fillColor,
            fillOpacity: 0.35,
            map: map
        });

        // 计算适合所有点的视图
        var bounds = new google.maps.LatLngBounds();
        path.forEach(point => bounds.extend(point));
        map.fitBounds(bounds);

        polygonArray.push({ id: id, overlay: polygon });
    };

    // 移除多边形
    this.removePolygonById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polygonArray, id);
    };

    // 清除所有多边形
    this.clearPolygons = function () {
        if (!loaded) return;
        removeElementFromArr(polygonArray);
    };

    // 添加圆形
    this.addCircle = function (id, center, radius, strokeWidth, strokeColor, fillColor, isReCenter = true) {

        if (!loaded) return;

        if (center == undefined || radius == undefined) return false;
        if (id == undefined || id == "") id = "circle0";

        if (strokeWidth == undefined) strokeWidth = 2;
        if (strokeColor == undefined) strokeColor = "#FF0000";
        if (fillColor == undefined) fillColor = "#FF0000";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#FF0000";
        if (fillColor.length != 7) fillColor = "#FF0000";

        var circle = new google.maps.Circle({
            strokeColor: strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: strokeWidth,
            fillColor: fillColor,
            fillOpacity: 0.35,
            map: map,
            center: { lat: center.lat, lng: center.lng },
            radius: radius
        });

        // 计算适合圆形的视图
        var bounds = new google.maps.LatLngBounds();
        bounds.extend(circle.getBounds().getNorthEast());
        bounds.extend(circle.getBounds().getSouthWest());
        if (isReCenter) {
            map.fitBounds(bounds);
        }

        circleArray.push({ id: id, overlay: circle });
    };
    this.removeClustererById = function (id) {
        if (!loaded) return;
        // console.log("removeClustererById" + id)

        // removeElementFromArr(labelArray, id);

        const findIndex = markerList.findIndex(m => m.markerId == id)
        if (findIndex === -1) {

            return
        }
        const delMarker = markerList[findIndex]

        if (clusterInstance) {
            try {
                if (typeof clusterInstance.removeMarker === 'function') {
                    clusterInstance.removeMarker(delMarker);
                } else if (typeof clusterInstance.removeMarkers === 'function') {
                    clusterInstance.removeMarkers([delMarker]);
                }
            } catch (e) {
                console.warn('Failed to remove marker:', e);
            }
        }

        delMarker.map = null
        // 2. 从数组删除
        markerList.splice(findIndex, 1)

        // this.refreshCluster()

    };
    // 移除圆形
    this.removeCircleById = function (id) {
        if (!loaded) return;
        removeElementFromArr(circleArray, id);
    };

    // 清除所有圆形
    this.clearCircles = function () {
        if (!loaded) return;
        removeElementFromArr(circleArray);
    };

    // 可以继续添加其他方法，如添加多边形等，与 BaiduMap 对应
    // ...
};

export { GoogleMap };